/**
 * TagEditModal - small modal wrapping TagEditor for asset tag editing.
 * Tags update live on toggle (no save button needed).
 */

import React from "react";
import { Modal } from "@/components/ui/Modal";
import { TagEditor } from "./TagEditor";

interface TagEditModalProps {
  isOpen: boolean;
  onClose: () => void;
  selectedTags: string[];
  onChange: (tags: string[]) => void;
}

export const TagEditModal: React.FC<TagEditModalProps> = ({
  isOpen,
  onClose,
  selectedTags,
  onChange,
}) => {
  return (
    <Modal isOpen={isOpen} onClose={onClose} title="Edit Tags" size="sm">
      <div className="p-6">
        <TagEditor selectedTags={selectedTags} onChange={onChange} />
      </div>
    </Modal>
  );
};
